import httpClient, { IRequest, IResponse, TRequestHeaders } from '../../../../apiService/httpClient';
import { getLanguage } from '../../../localization';
import { IProjectMacra1 } from '../../store/project/projectSlice';
import { IProjectResultResponse } from '../IApiResponse';

const BeMaccaferriCalculationProvider = () => {
    let _baseURL = (process.env.ENVIRONMENT as string) === 'local' ? process.env.CALCULATION_BASE_URL as string : '/';

    const _createRequest = <D>(_pathname: string, _queryString?: string, _data?: D): IRequest => {
        return {
            url: _queryString ? _pathname + '?' + _queryString : _pathname,
            baseURL: _baseURL,
            data: _data,
        };
    };

    const _createHeaders = (): TRequestHeaders => {
        return {
            'Accept-Language': getLanguage(),
        };
    };

    //calculation
    const getResultsAsync = async (data: IProjectMacra1): Promise<IResponse<IProjectResultResponse>> =>
        httpClient.postAsync(_createRequest(`api/Calculation/GetResultsMacra1`, '', data), _createHeaders());

    return {
        getResultsAsync,
    };
};
export default BeMaccaferriCalculationProvider();
